import kaspiLoader from "../../assets/images/kaspi/kaspi-loader.svg";
import kaspiSuccess from "../../assets/images/kaspi/kaspi-success.svg";
import kaspiError from "../../assets/images/kaspi/kaspi-error.svg";
import c from "./styles.module.scss";

const KaspiStatus = ({ status, amount }) => {
  if (!status) {
    return null;
  }

  const formattedAmount = amount
    ? new Intl.NumberFormat("ru-RU", {
        useGrouping: true,
        maximumFractionDigits: 0,
      }).format(amount)
    : null;

  return (
    <div className={c.kaspiStatus}>
      <div className={c.kaspiStatusCard}>
        {status === "QrTokenCreated" ? (
          <p className={c.kaspiStatusTitle}>
            Подтвердите оплату <br /> в Kaspi
          </p>
        ) : null}

        {status === "Wait" ? (
          <img
            className={c.kaspiStatusLoader}
            src={kaspiLoader}
            width="80"
            height="80"
            alt="loading"
          />
        ) : null}

        {status === "Processed" ? (
          <>
            <img
              className={c.kaspiStatusIcon}
              src={kaspiSuccess}
              width="150"
              height="150"
              alt="success"
            />
            <p className={c.kaspiStatusTitle}>Оплата принята</p>
            {formattedAmount ? (
              <p className={c.kaspiStatusAmount}>{formattedAmount} ₸</p>
            ) : null}
          </>
        ) : null}

        {status === "Cancelled" ? (
          <>
            <img
              className={c.kaspiStatusIcon}
              src={kaspiError}
              width="150"
              height="150"
              alt="cancelled"
            />
            <p className={c.kaspiStatusTitle}>Отмена покупки</p>
            <p className={c.kaspiStatusSubtitle}>Вы не подтвердили оплату</p>
          </>
        ) : null}

        {status === "Expired" ? (
          <>
            <img
              className={c.kaspiStatusIcon}
              src={kaspiError}
              width="150"
              height="150"
              alt="expired"
            />
            <p className={c.kaspiStatusTitle}>Срок действия истек</p>
            <p className={c.kaspiStatusSubtitle}>Создайте платеж заново</p>
          </>
        ) : null}

        {status === "Timeout" ? (
          <>
            <img
              className={c.kaspiStatusIcon}
              src={kaspiError}
              width="150"
              height="150"
              alt="timeout"
            />
            <p className={c.kaspiStatusTitle}>Время подтверждения истекло</p>
          </>
        ) : null}

        {status === "Error" ? (
          <>
            <img
              className={c.kaspiStatusIcon}
              src={kaspiError}
              width="150"
              height="150"
              alt="error"
            />
            <p className={c.kaspiStatusTitle}>Ошибка оплаты</p>
            <p className={c.kaspiStatusSubtitle}>Попробуйте еще раз</p>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default KaspiStatus;
